import clsx from 'clsx';

import style from './MultiTagDisplay.module.css';
import { Tag } from './Tag';

export interface MultiTagDisplayProps {
  tags: string[];
}
export const MultiTagDisplay = ({ tags }: MultiTagDisplayProps) => {
  return (
    <div className={clsx(style.root)}>
      {tags.map((tag) => (
        <Tag key={tag}>{tag}</Tag>
      ))}
    </div>
  );
};
